/* eslint-disable */
import React from 'react';
import Card from '@material-ui/core/Card';
import '../css/ClientLoginPage.css';
import { Divider } from '@material-ui/core';

/**
 * @component The component renders the Devleopments page
 * @return {Component} DevelopmentsPage component
 */
export default function ClientPage() {
  return (
    <div className="client-root">
      <div className="client-container">
        <h1>Client Portal</h1>
        <br />
        <form className="client-form" method="post">
          <h3 style={{}}>Username</h3>
          <input type="text" name="" placeholder="Username"></input>
          <h3 style={{}}>Password</h3>
          <input type="password" name="" placeholder="Password"></input>
          <h3></h3>
          <input type="submit" name="" value="Login"></input>
          <h3></h3>
        </form>
      </div>
      <br />
      {/* <div className="client-bottom-links">
        <a href="/client-login">Legal</a>
        <p>&nbsp;&nbsp;|&nbsp;&nbsp;</p>
        <a href="/client-login">Disclaimers</a>
        <p>&nbsp;&nbsp;|&nbsp;&nbsp;</p>
        <a href="/client-login">Privacy Policy</a>
      </div> */}
    </div>
  );
}
